import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function grossNotBelowNetValidator(netControlName = 'netQuantity', grossControlName = 'grossQuantity'): ValidatorFn {
  return (group: AbstractControl): ValidationErrors | null => {
    const net = group.get(netControlName)?.value;
    const gross = group.get(grossControlName)?.value;
    if (net == null || gross == null) {
      return null;
    }
    return gross < net ? { grossBelowNet: true } : null;
  };
}
